import { RegistrationListReportTemplateData } from "./RegistrationListReportTemplateData";
import { backgroundLogo, headerLogo } from "../constants/PdfReports";
import { formatDate } from "../core/Utility";

export const RegistrationListReportImportTemplate = (
  data: RegistrationListReportTemplateData
) => {
  return {
    background: [
      {
        image: backgroundLogo,
        width: 400,
        alignment: "center",
        absolutePosition: { x: 0, y: 160 },
      },
    ],
    pageOrientation: "landscape",
    pageSize: "A4",
    margin: [0, 0, 0, 0],
    header: [],
    footer: [],
    content: [
      {
        image: headerLogo,
        alignment: "center",
        margin: [0, 5, 0, 0],
      },
      {
        text: `Lista prijava`,
        style: "title",
        margin: [0, 20, 0, 5],
      },
      {
        canvas: [
          {
            lineColor: "gray",
            type: "line",
            x1: 0,
            y1: 0,
            x2: 735,
            y2: 0,
            lineWidth: 1,
          },
        ],
        margin: [0, 5, 0, 10],
      },
      {
        width: "50%",
        layout: "noBorders",
        table: {
          widths: ["15%", "15%", "15%", "10%", "15%", "10%", "10%", "10%"],
          body: [
            [
              {
                columns: [
                  {
                    width: "100%",
                    text: `Ime: `,
                    style: "textLeft",
                    bold: true,
                    margin: [0, 0, 0, 0],
                  },
                ],
              },
              {
                columns: [
                  {
                    width: "100%",
                    text: `Prezime: `,
                    style: "textLeft",
                    bold: true,
                    margin: [0, 0, 0, 0],
                  },
                ],
              },
              {
                columns: [
                  {
                    text: `Događaj: `,
                    style: "textLeft",
                    bold: true,
                    margin: [0, 0, 0, 0],
                  },
                ],
              },
              {
                columns: [
                  {
                    text: `Tip: `,
                    style: "textLeft",
                    bold: true,
                    margin: [0, 0, 0, 0],
                  },
                ],
              },
              {
                columns: [
                  {
                    text: `Pravno lice: `,
                    style: "textLeft",
                    bold: true,
                    margin: [0, 0, 0, 0],
                  },
                ],
              },
              {
                columns: [
                  {
                    text: `Tip sobe: `,
                    style: "textLeft",
                    bold: true,
                    margin: [0, 0, 0, 0],
                  },
                ],
              },
              {
                columns: [
                  {
                    text: `Datum prijave: `,
                    style: "textLeft",
                    bold: true,
                    margin: [0, 0, 0, 0],
                  },
                ],
              },
              {
                columns: [
                  {
                    text: `Status: `,
                    style: "textLeft",
                    bold: true,
                    margin: [0, 0, 0, 0],
                  },
                ],
              },
            ],
          ],
        },
      },
      {
        canvas: [
          {
            lineColor: "gray",
            type: "line",
            x1: 0,
            y1: 0,
            x2: 735,
            y2: 0,
            lineWidth: 1,
          },
        ],
        margin: [0, 5, 0, 10],
      },
      data.reportData?.map((item) => {
        return {
          width: "50%",
          layout: "noBorders",
          table: {
            widths: ["15%", "15%", "15%", "10%", "15%", "10%", "10%", "10%"],
            body: [
              [
                {
                  columns: [
                    {
                      text: `${item.firstName ?? ""}`,
                      style: "textLeft",
                      bold: false,
                      margin: [0, 0, 0, 0],
                    },
                  ],
                },
                {
                  columns: [
                    {
                      text: `${item.lastName ?? ""}`,
                      style: "textLeft",
                      bold: false,
                      margin: [0, 0, 0, 0],
                    },
                  ],
                },
                {
                  columns: [
                    {
                      text: `${
                        item?.event?.name == null ? "" : item?.event?.name
                      }`,
                      style: "textLeft",
                      bold: false,
                      margin: [0, 0, 0, 0],
                    },
                  ],
                },
                {
                  columns: [
                    {
                      text: `${item.type ?? "/"}`,
                      style: "textLeft",
                      bold: false,
                      margin: [0, 0, 0, 0],
                    },
                  ],
                },
                {
                  columns: [
                    {
                      text: `${item.companyName}`,
                      style: "textLeft",
                      margin: [0, 0, 0, 0],
                    },
                  ],
                },
                {
                  columns: [
                    {
                      //@ts-ignore
                      text: `${item.eventXRoomType?.roomType?.name ?? ""}`,
                      style: "textLeft",
                      margin: [0, 0, 0, 0],
                    },
                  ],
                },
                {
                  columns: [
                    {
                      //@ts-ignore
                      text: `${formatDate(new Date(item.createdAt))}`,
                      style: "textLeft",
                      margin: [0, 0, 0, 0],
                    },
                  ],
                },
                {
                  columns: [
                    {
                      text: `${item.status}`,
                      style: "textLeft",
                      margin: [0, 0, 0, 0],
                    },
                  ],
                },
              ],
            ],
          },
        };
      }),
      {
        canvas: [
          {
            lineColor: "gray",
            type: "line",
            x1: 0,
            y1: 0,
            x2: 735,
            y2: 0,
            lineWidth: 1,
          },
        ],
        margin: [0, 5, 0, 10],
      },
    ],
    styles: {
      title: {
        fontSize: "14",
        alignment: "center",
        margin: [0, 20, 0, 10],
        bold: true,
      },
      textLeft: {
        fontSize: "10",
        alignment: "left",
      },
      textRight: {
        fontSize: "10",
        alignment: "right",
      },
    },
  };
};
